class BurgerDrawer extends Drawer {
  constructor() {
    super();

    const trigger = document.querySelector('.navbar__burger');
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', () => this.open(trigger));
    }
  }

  connectedCallback() {
    // Move to <body> so the drawer escapes any stacking context
    // created by the sticky header wrapper.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }
  }
}

customElements.define('burger-drawer', BurgerDrawer);
